import { initList } from './list.js';
import { initDetail } from './detail.js';
import { initResizeHandler, initQuestionForm } from './handlers.js';
import { initFileAttachment } from './attachment.js';

/**
 * Initialize Student Question module
 */
export function initStudentQuestion() {
	initList();
	initDetail();
	initResizeHandler();
	initFileAttachment();
	initQuestionForm();
}
